import 'offline-js/offline'
import 'offline-js/themes/offline-language-english.css'
import 'offline-js/themes/offline-theme-chrome.css'
import React from 'react'
import { connect, type ConnectedProps } from 'react-redux'
import {
  changeOnlineStatus,
  checkUpdate,
} from '@disco/state-management/actions/AppActions'

const connector = connect(null, {
  checkUpdate,
  changeOnlineStatus,
})

type Props = ConnectedProps<typeof connector>

class Offline extends React.Component<Props> {
  componentDidMount() {
    const processHost = process.env.HOST ?? ''
    const { Offline } = window
    // Use this url to check if internet connection is on (maybe create a specific endpoint for this)
    Offline.options = {
      checks: {
        xhr: {
          url: `${window.host || processHost}/ping`,
        },
      },
      requests: false,
    }
    Offline.on('up', this.handleReconnect, this)
    Offline.on('down', this.handleOffline, this)
  }

  handleReconnect = () => {
    const { checkUpdate, changeOnlineStatus } = this.props
    checkUpdate()
    changeOnlineStatus(true)
  }
  handleOffline = () => this.props.changeOnlineStatus(false)

  componentWillUnmount() {
    const { Offline } = window
    Offline.off('up', this.handleReconnect)
    Offline.off('down', this.handleOffline)
  }

  render() {
    return null
  }
}

export default connector(Offline)